import { render, staticRenderFns } from "./AdresList.vue?vue&type=template&id=620661d7"
import script from "./AdresList.vue?vue&type=script&lang=ts"
export * from "./AdresList.vue?vue&type=script&lang=ts"
import style0 from "./AdresList.vue?vue&type=style&index=0&id=620661d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports